module.exports = __webpack_public_path__ + "static/mask_lo_088-a1d908494b524755ca0e07840bcf8f58.jpg";